import React, { useEffect } from "react";
import { Outlet } from "react-router";
import Header from "./Components/Home/Header";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import Footer from "./Components/assets/Footer";

const googleAnalyticsId = process.env.REACT_APP_GOOGLE_MEASUREMENT_ID;
if (googleAnalyticsId) {
  try {
    ReactGA.initialize(googleAnalyticsId);
    console.log("Google Analytics initialized successfully");
  } catch (error) {
    console.error("Failed to initialize Google Analytics:", error);
  }
}

const DefaultContainer = () => {
  const location = useLocation();
  console.log("googleAnalyticsId is : ", googleAnalyticsId);

  useEffect(() => {
    if (googleAnalyticsId) {
      try {
        ReactGA.send({
          hitType: "pageview",
          page: location.pathname + location.search,
        });
        console.log(
          `Pageview sent for: ${location.pathname + location.search}`
        );
      } catch (error) {
        console.error("Failed to send pageview to Google Analytics:", error);
      }
    } else {
      console.warn("Google Analytics Measurement ID is not defined");
    }
  }, [location]);

  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </> 
  );
};

export default DefaultContainer;
